


























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ContractService from '@/domain/contract/service/contract.service';
import ContractItemAutomation from '@/domain/contract/entity/contract-item-automations.entity'
import ModalOptions from '../../../../../shared/modal/modal-options.entity';

const isNullOrEmpty = (field: any): boolean => field === null || field === '';

@Component({
  components: { ModalComponent },
})
export default class ContractItemAutomationModal extends Vue {
  @Prop({ type: Boolean, default: false })
  private value!: boolean;

  @Prop({ type: String, required: true })
  private contractItemId!: string;

  @Prop({ type: Boolean, required: true })
  private autoPurchase!: boolean;

  private loading: boolean = false;

  private automations: ContractItemAutomation = new ContractItemAutomation();

  private dayHint: string = 'Caso o dia selecionado seja após o dia 28, nos meses que esse dia não existir, será utilizado o último dia do mês.';

  private labelInfo: string = 'Devido o agendamento estar programado para o dia atual, não é possível alterar a hora';

  get getHintHour(): string {
    const date: Date = new Date();
    if ((this.automations.day === date.getDay())) {
      return this.labelInfo;
    }
    return 'Formato: 0-23h';
  }

  get disableField(): boolean {
    const date: Date = new Date();
    return (this.automations.day === date.getDay());
  }

  private dayRules = [(day) => {
    if (day === '' || day === null) return true;
    if (day < 1 || day > 31) return 'O dia deve estar entre 1 e 31';
    return true;
  }];

  private hourRules = [(hour) => {
    if (hour === '' || hour === null) return true;
    if (hour < 0 || hour > 23) return 'A hora deve estar entre 0 e 23';
    return true;
  }];

  get options(): ModalOptions {
    return {
      title: 'Automatização de Faturamento',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 720,
      persistent: false,
    }
  }

  saveAutomation(): void {
    const { form }: any = this.$refs;
    if (!form.validate()) return;
    if (!this.bothOrNoneFilled()) {
      VbSnackbarService.showError('Dia e hora devem ambos serem preenchidos ou vazios.');
      return;
    }
    ContractService.putAutomations(this.contractItemId, this.automations)
      .then(this.cancel)
      .catch(VbSnackbarService.handleHttpError);
  }

  cancel(): void {
    this.$emit('cancel');
  }

  bothOrNoneFilled(): boolean {
    return (isNullOrEmpty(this.automations.day) && isNullOrEmpty(this.automations.hour))
      || (!isNullOrEmpty(this.automations.day) && !isNullOrEmpty(this.automations.hour))
  }

  searchAutomations() {
    this.loading = true;
    ContractService.getAutomations(this.contractItemId)
      .then((automation: ContractItemAutomation) => {
        this.automations = automation;
      }).catch(() => this.automations = new ContractItemAutomation())
      .finally(() => this.loading = false);
  }
}
